import { createDecorator } from "vue-class-component";
import Vue from "vue";
import { httpStore } from "@/store/typed";
import StoreSubscriber from "@/utils/StoreSubscriber";

export const NoCache = createDecorator((options, key) => {
  // component options should be passed to the callback
  // and update for the options object affect the component
  if (options?.computed) {
    (options.computed[key] as any).cache = false;
  }
});

export const RegisterHttp = (tag: string) => {
  return createDecorator((options, key) => {
    const beforeCreate = function (this: Vue) {
      httpStore.dispatchRegister(tag);
    };

    if (options.beforeCreate) {
      const oldBeforeCreate = options.beforeCreate;
      options.beforeCreate = function () {
        oldBeforeCreate.bind(this)();
        beforeCreate.bind(this)();
      };
    } else {
      options.beforeCreate = beforeCreate;
    }
    if (!options.computed) {
      options.computed = {};
    }
    options.computed[key] = function mappedGetter() {
      return httpStore.status[tag];
    };
  });
};

export const StoreSubscribe = (mutationName: string) => {
  return createDecorator((options, key) => {
    // eslint-disable-next-line
    const bindings: { [key: string]: (...args: any[]) => void } = {};
    let destroyedFunction: Function;
    const beforeCreate = function (this: Vue) {
      if (options.methods) {
        bindings[mutationName] = options.methods[key].bind(this);
        destroyedFunction = StoreSubscriber.subscribe(
          mutationName,
          bindings[mutationName]
        );
      }
    };

    const destroyed = function (this: Vue) {
      destroyedFunction();
    };

    if (options.beforeCreate) {
      const oldBeforeCreate = options.beforeCreate;
      options.beforeCreate = function () {
        oldBeforeCreate.bind(this)();
        beforeCreate.bind(this)();
      };
    } else {
      options.beforeCreate = beforeCreate;
    }

    if (options.destroyed) {
      const olddestroyed = options.destroyed;
      options.destroyed = function (this: Vue) {
        olddestroyed.bind(this)();
        destroyed.bind(this)();
      };
    } else {
      options.destroyed = destroyed;
    }
  });
};
